<template>
  <Transition name="slide-fade">
    <div class="bckcolor" v-show="show" ref="noticiaswrapper">
      <div class="row align-center">
        <div class="small-12 medium-7 large-7 columns npadding noticiaslist">
          <h1>{{ $translate("UMA_LANG_FACULDADE_ULTIMASNOTICIAS") }}</h1>
          <p class="semnoticias" v-if="noticias.length == 0">
            <img src="@/assets/error_icon-29.png"/>{{ $translate("UMA_LANG_FACULDADE_SEMNOTICIAS") }}
          </p>
          <div class="noticiagrid">
            <NoticiaElem
                :url="noticia.url"
                :imagem="noticia.noticia_imagem"
                :titulo="noticia.post_title"
                :ref="`n${index}`"
                v-for="(noticia,index) in noticias"/>
          </div>
          <Button
              @click="seeMoreNoticias"
              class="btn"
              :class="$store.state.faculdadename"
              :text="$translate('UMA_LANG_FACULDADE_CONSULTARNOTICIAS')" />
        </div>
        <div class="small-12 medium-4 large-4 columns eventoslist">
          <h1>{{ $translate("UMA_LANG_FACULDADE_ULTIMOSEVENTOS") }}</h1>
          <Evento
              :url="evento.url"
              :titulo="evento.post_title"
              :local="evento.local"
              :mes="evento.mes"
              :dia="evento.dia"
              :class="{'last':evindex == eventos.length-1}"
              v-for="(evento,evindex) in eventos"/>
          <p class="semeventos" v-if="eventos.length == 0">
            <img src="@/assets/error_icon-29.png"/>{{ $translate("UMA_LANG_FACULDADE_SEMEVENTOS") }}
          </p>
          <Button
              @click="seeMoreEventos"
              class="btn eventos"
              :class="$store.state.faculdadename"
              :text="$translate('UMA_LANG_FACULDADE_CONSULTAREVENTOS')" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>

import axios from "../../axios.js";
import NoticiaElem from "../../components/NoticiaElem.vue";
import Button from "../../components/Button.vue";
import Evento from "../../components/Evento.vue";

export default {
  name: "FaculdadeNoticiasGrid",
  components:{
    NoticiaElem,
    Button,
    Evento
  },
  inject:["id","language"],
  data(){
    return {
      show: false,
      noticiaHeigth: 0,
      noticias: [],
      eventos:[],
    }
  },
  created() {
    this.fetchNoticias();
    this.fetchEventos();
  },
  mounted(){
    window.addEventListener("scroll",()=>{
      if(!this.show){
        if(this.isOnViewPort(this.$refs.noticiaswrapper)){
          this.show = true;
        }
      }
    });
  },
  methods:{
    fetchEventos(){
      axios.get(`/faculdades/${this.id}/eventos/latest?idioma=${this.language}`).
      then(data => {
        const formatter = new Intl.DateTimeFormat("pt-PT", {
          day: "2-digit",
        });
        const formatermont = new Intl.DateTimeFormat("pt-PT",{
          month: "short",
        });
        const l = this.language == "pt" ? "" : "en/";
        this.eventos = data.data.map(el => {
          const { noticia_data_evento } = el;
          const date = new Date(noticia_data_evento);
          return {
            ...el,
            local: el.noticia_horaevento,
            dia: formatter.format(date),
            mes: formatermont.format(date),
            url: `${import.meta.env.VITE_APP_SITE_URL}/${l}noticias/${el.post_name}`
          }
        });
      }).catch(error => {
        console.log(error);
      });
    },
    fetchNoticias(){
      axios.get(`/faculdades/${this.id}/noticiaseventos?idioma=${this.language}`).
          then(data => {
            const l = this.language == "pt" ? "" : "en/";
            this.noticias = data.data.map(el => {
              return {
                ...el,
                url: `${import.meta.env.VITE_APP_SITE_URL}/${l}noticias/${el.post_name}`
              }
            });
      }).catch(error => {
        console.log(error);
      })
    },
    isOnViewPort(el){
      var rect = el.getBoundingClientRect();
      return (
          rect.bottom >= 0 &&
          rect.top <= window.innerHeight &&
          rect.right >= 0 &&
          rect.left <= window.innerWidth
      )
    },
    seeMoreEventos(){
      const l = this.language == "pt" ? "" : "en/";
      window.location = `https://www.uma.pt/${l}eventos/?faculdadefilter=${this.id}`;
    },
    seeMoreNoticias(){
      const l = this.language == "pt" ? "" : "en/";
      window.location = `https://www.uma.pt/${l}noticias/?faculdadefilter=${this.id}`;
    },
    setDimensions(height){
      this.noticiaHeigth = height;
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/global";

.semeventos,.semnoticias {
  font-family: "Montserrat";
  color: #434141;
  /*margin-bottom: 15px;*/
}

.semnoticias{
  margin-left: 28px;
  margin-bottom: 40px;
}

.semeventos img,.semnoticias img{
  width: 38px;
  margin-right: 10px;
  margin-bottom: 5px;
}

@media (max-width: 767px) {
  .semeventos img,.semnoticias img{
    width: 33px;
  }

  .semeventos,.semnoticias{
    font-size: 14px;
  }
}

.noticiagrid{
  padding: 0;
  font-size: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 16px;
  margin: 0 19px 0 15px;
}

.noticiaslist h1 {
  color: #343333;
  margin-left: 28px;
  margin-bottom: 23px;
}

.eventoslist h1 {
  color: #343333;
  margin-left: 8px;
  margin-bottom: 23px;
}

.noticiaslist .button {
  margin-left: 28px;
}

.bckcolor .row {
  padding-right: 55px;
  padding-left: 55px;
}

@media (max-width: 767px) {
  .noticiagrid{
    grid-template-columns: repeat(1, 1fr);
    grid-auto-rows: 1fr;
  }
}

.row .row{
  margin-left: 0;
  margin-right: 0;
}

.slide-fade-enter-active {
  opacity: 1;
  transition-property: opacity, transform;
  transition-duration: .8s, 1s;
  transition-timing-function: ease-in, ease-in;
  transition-delay: 0.2s, 0.2s;
  transform: translate3D(0,0px,0);
}

.slide-fade-enter-from{
  opacity: 0;
  transform: translate3D(0,-20px,0);
}
/*
.btn.artesehumanidades{
  background-color: $ahline;
}

a.btn.artesehumanidades:hover {
  background: $artesHumanidades !important;
}

.btn.cienciasexatasedaengenharia{
  background-color: $ceeline;
}

a.btn.cienciasexatasedaengenharia:hover {
  background: $cee2 !important;
}

.btn.cienciassociais{
  background-color: $csline;
}

a.btn.cienciassociais:hover {
  background: $cs !important;
}

.btn.cienciasdavida{
  background-color: $cvhline;
}

a.btn.cienciasdavida:hover {
  background: $cv !important;
}

.btn.escolasuperiordetecnologiasegestao{
  background-color: $tghline;
}

a.btn.escolasuperiordetecnologiasegestao:hover {
  background: $estg2 !important;
}

.btn.escolasuperiordesaude{
  background-color: $ssline;
}

a.btn.escolasuperiordesaude:hover {
  background: $ess2 !important;
}*/

.btn.artesehumanidades{
  background-color: $ahc1;
}

a.btn.artesehumanidades:hover {
  background: $ahc2 !important;
}

.btn.cienciasexatasedaengenharia{
  background-color: $ceec1;
}

a.btn.cienciasexatasedaengenharia:hover {
  background: $ceec2 !important;
}

.btn.cienciassociais{
  background-color: $ccc1;
}

a.btn.cienciassociais:hover {
  background: $ccc2 !important;
}

.btn.cienciasdavida{
  background-color: $cvc1;
}

a.btn.cienciasdavida:hover {
  background: $cvc2 !important;
}

.btn.escolasuperiordetecnologiasegestao{
  background-color: $estgc1;
}

a.btn.escolasuperiordetecnologiasegestao:hover {
  background: $estgc2 !important;
}

.btn.escolasuperiordesaude{
  background-color: $essc1;
}

a.btn.escolasuperiordesaude:hover {
  background: $essc2 !important;
}

.eventoslist{
  position: relative;
  padding-bottom: 60px;
}

.evento.last{
  margin-bottom: 30px;
}

.btn.eventos{
  position: absolute;
  bottom: 0;
}

.bckcolor{
  background: #f2f2f2;
  padding-top: 100px;
  padding-bottom: 100px;
}

h1{
  font-size: 25px;
  font-family: 'Montserrat SemiBold';
  margin-bottom: 15px;
}

@media (max-width: 1500px) {
  .bckcolor .row {
    padding-right: 0;
    padding-left: 0;
  }

  .bckcolor {
    padding-top: 65px;
    padding-bottom: 65px;
  }
}


@media (max-width: 1024px) {
  .noticiaslist,.eventoslist{
    flex: 0 0 83.333%;
    max-width: 83.333%;
    -webkit-box-flex: 0;
  }

  .btn, .btn.eventos{
    width: 360px;
    display: block;
    position: relative;
    margin: 40px auto 0;
  }

  .eventoslist{
    margin-top: 60px;
    margin-bottom: 0;
    padding-bottom: 0;
  }

}

@media (max-width: 839px) {

  .bckcolor {
    padding: 35px 0;
  }

}


@media (max-width: 767px) {

  h1{
    font-size: 21px;
  }

  .noticiagrid{
    margin-left: 0;
    margin-right: 0;
  }

  .npadding,.newcolumn{
    padding-right: 0;
    padding-left: 0;
  }

  .btn.eventos{
    position: relative;
  }

  .eventoslist{
    margin-top: 60px;
    padding-right: 0;
    padding-left: 0;
  }

  .noticiaslist h1 {
    font-size: 19px;
    margin-left: 5px;
  }

  .noticiaslist .button {
    width: 290px;
    margin-left: auto;
    margin-top: 25px;
  }

  .eventoslist h1 {
    font-size: 19px;
    margin-left: 5px;
  }

  .btn.eventos {
    width: 290px;
    margin-left: auto;
    margin-top: 10px;
  }
}

</style>